'use strict';

angular.module('atex.dam').factory('DamSocialNotificationService', ['$q', 'ContentService', 'configuration', 'DamService', 'DamNotificationService',
  function ($q, ContentService, configuration, DamService, DamNotificationService) {
    var isJob = function (type) {
      return (type === "atex.dam.standard.Job");
    };

    var sendNotification = function (id) {
      var data = {
        "id": id
      };

      DamService.sendSlackMessage(data).then(null, function () {
        var message = "Cannot sent message to Slack system";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    };

    return {
      sendMessage: function (id, type) {
        if(isJob(type)) {
          sendNotification(id);
        }
      }
    };
  }]);
